import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { FirstDataRenderedEvent, GridReadyEvent, NewColumnsLoadedEvent } from 'ag-grid-community/dist/lib/events';
import * as moment from 'moment';
import { PayScalesService } from '../../pay-scales.service';
import { ICalculatedPilotRates, IPilot } from '../../pay-scales.types';
import { CurrencyComponent } from '../years-of-service/currency.component';

/**
 * Handles display of pay card
 */
@Component({
	selector: 'app-pay-scales-pilots-card',
	templateUrl: './pay-scales-pilots-card.component.html'
})
export class PayScalesPilotsCardComponent implements OnChanges, OnInit {
	constructor(private payScalesService: PayScalesService) {
		this.gridOptions = {
			defaultColDef: {
				resizable: true
			},
			onGridReady: (params: GridReadyEvent): void => {
				params.api.sizeColumnsToFit();
			},
			onNewColumnsLoaded: (params: NewColumnsLoadedEvent): void => {
				params.api.sizeColumnsToFit();
			},
			onFirstDataRendered: this.onFirstDataRendered
		};
	}

	@Input() public pilots: IPilot[];
	@Input() public isInstructorPayScale: boolean = false;
	@Input() public constantAPBonus: number = 0;
	@Input() public isAddRecord: boolean = false;
	@Input() public isApRatingPayScale: boolean = false;

	public calculatedPilotRates: ICalculatedPilotRates[];
	public now: moment.Moment = moment.utc();
	public pilotColumnDefs: ColDef[] = [];
	public result: string = '';
	public gridOptions: GridOptions;

	public ngOnInit(): void {
		if (!this.pilots) {
			return;
		}
	}

	public ngOnChanges(): void {
		this.calculatedPilotRates = this.pilots.map(pilot => ({
			...this.payScalesService.calculatePayScaleRates(0, pilot.payScale)[0],
			hireDate: this.getAnniversaryDate(pilot.hireDate),
			name: `${pilot.firstName} ${pilot.lastName}`
		}));

		this.pilotColumnDefs = [
			{
				headerName: 'Pilot',
				field: 'name'
			},
			{
				headerName: 'Year of Service',
				field: 'yearsOfService'
			},
			{
				headerName: 'Anniversary Date',
				field: 'hireDate'
			},
			{
				headerName: 'Guaranteed Hours',
				field: 'guaranteedHours'
			},
			{
				headerName: 'Hourly Rate',
				field: 'hourlyRateDollars'
			},
			{
				headerName: 'Instructor Pay',
				field: 'instructorPayDollars',
				hide: !this.isInstructorPayScale
			},
			{
				headerName: 'Bi-Weekly',
				field: 'biWeeklyRate',
				cellRendererFramework: CurrencyComponent
			},
			{
				headerName: 'Bi-Weekly A&P',
				field: 'apBiWeeklyRate',
				cellRendererFramework: CurrencyComponent,
				hide: !this.isApRatingPayScale
			},
			{
				headerName: 'Bi-Weekly Instructor',
				field: 'biWeeklyInstructorRate',
				hide: !this.isInstructorPayScale,
				cellRendererFramework: CurrencyComponent
			},
			{
				headerName: 'Monthly',
				field: 'monthlyRate',
				cellRendererFramework: CurrencyComponent
			},
			{
				headerName: 'Annual',
				field: 'annualRate',
				cellRendererFramework: CurrencyComponent
			},
			{
				headerName: 'Annual A&P',
				field: 'apAnnualRate',
				cellRendererFramework: CurrencyComponent,
				hide: !this.isApRatingPayScale
			}
		];
	}

	public onFirstDataRendered(params: FirstDataRenderedEvent): void {
		params.api.sizeColumnsToFit();
	}

	/**
	 *
	 * getAnniversaryDate
	 */
	private getAnniversaryDate(date: string): string {
		const hireDate: moment.Moment = moment.utc(date);
		const currentMonth: number = this.now.month();
		const hireMonth: number = hireDate.month();
		const currentDay: number = this.now.date();
		const hireDay: number = hireDate.date();
		let year: number = this.now.year();

		const isNeedNextYear: boolean =
			currentMonth > hireMonth ? true : currentMonth === hireMonth && currentDay > hireDay;

		if (isNeedNextYear) {
			year += 1;
		}

		return moment.utc([year, hireMonth, hireDay]).format('YYYY-MM-DD');
	}
}
